import { graphql } from "relay-runtime"

export const deBetterDocUsageForConsultationQuery = graphql`
  query useDeBetterDocUsageForConsultationQuery(
    $patientId: ID!
    $diagnosisCode: String
    $effectivePointOfCare: PointOfCareType!
    $specialtyId: ID
  ) {
    betterDocUsageForConsultation: de_betterDocUsageForConsultation(
      patientId: $patientId
      diagnosisCode: $diagnosisCode
      effectivePointOfCare: $effectivePointOfCare
      specialtyId: $specialtyId
    )
    missingConsultationDetailsThatCanChangeBetterDocUsage: de_missingConsultationDetailsThatCanChangeBetterDocUsage(
      patientId: $patientId
      diagnosisCode: $diagnosisCode
      effectivePointOfCare: $effectivePointOfCare
      specialtyId: $specialtyId
    )
  }
`
